import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'tv-section-header',
  templateUrl: './section.header.component.html',
  styleUrls: [
    './section.header.component.css'
  ]
})
export class SectionHeaderComponent {
  @Input() public title = '';

  constructor(private titleService: Title) {
    this.setTitle(this.title);
  }

  private setTitle(title: string) {
    this.titleService.setTitle(title);
    this.title = title;
  }
}
